import { createSlice } from '@reduxjs/toolkit';
import { getCompleteAddress } from './AddressApi';

const initialState = {
    isLoadingParticipantAddress: false,
    participantCompleteAddress: {},
    error: null,
};

const addressSlice = createSlice({
    name: 'addressSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCompleteAddress.pending, (state) => {
                state.isLoadingParticipantAddress = true;
            })
            .addCase(getCompleteAddress.fulfilled, (state, { payload }) => {
                state.isLoadingParticipantAddress = false;
                state.error = null;
                state.participantCompleteAddress = payload.data;
            })
            .addCase(getCompleteAddress.rejected, (state, { meta, error }) => {

                state.isLoadingParticipantAddress = false;
                if (error.message.includes('422')) {
                    state.error = `CEP ${meta.arg} não encontrado.`;
                } else {
                    state.error = 'Não foi possível pesquisar o CEP informado!'
                }
            })
    },
});

export default addressSlice.reducer;
